import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { HttpTestService } from "app/services/http.service";
import { sessionServices } from "app/services/session.services";
import { IMyDpOptions } from "mydatepicker";
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-view-prepaid-transaction",
  templateUrl: "./view-prepaid-transaction.component.html",
  styleUrls: ["./view-prepaid-transaction.component.css"],
})
export class ViewPrepaidTransactionComponent implements OnInit {
  public errorMsg: string = "";
  public serviceOn: boolean = false;
  public today: any = new Date();
  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: "dd-mm-yyyy",
  };
  //   public fromDate: any = this.datePipe.transform(
  //     new Date(new Date().setDate(new Date().getDate() - 180)),
  //     "yyyy-MM-dd"
  //   );
  //   public toDate: any = this.datePipe.transform(new Date(), "yyyy-MM-dd");
  fromDate: any = null;
  toDate: any = null;
  public displayDateFilterError: boolean = false;
  public isHideTable: boolean = false;
  public sessionData: any;
  public showTransactionTable: boolean = false;
  public showForm: boolean = true;
  public prepaidConsumerForm: FormGroup;
  public captchaView: string = "";
  public isCaptchaMatched: boolean = true;
  public transactionList: any = [];
  pageNo: number = 0;
  pageSize: number = 10;
  maxPageNo: number = 0;
  paginationLinks: number[] = [1, 2, 3];
  totalCount: any;
  public consumerNoShow: any = "";
  public vendorId: any = [];

  prepaidValidation_messages = {
    consumerNumber: [
      {
        type: "required",
        message: "Consumer id is mandatory",
      },
      {
        type: "pattern",
        message: "Consumer id is not valid.",
      },
    ],
    meterNo: [
      {
        type: "required",
        message: "Please enter meter number",
      },
    ],
    captcha: [
      {
        type: "required",
        message: "Please enter the above captcha",
      },
    ],
  };
  elementRef: any;


  constructor(
    public session: sessionServices,
    public httpService: HttpTestService,
    public formBuilder: FormBuilder,
    private datePipe: DatePipe
  ) {
    this.generateCaptcha();
    this.initiateForm();
  }

  ngOnInit() {
    this.getSession();
    this.fromDate = this.datePipe.transform(
      new Date(new Date().getTime() - 180 * 24 * 3600 * 1000),
      "yyyy-MM-dd"
    );
    this.toDate = this.datePipe.transform(new Date(), "yyyy-MM-dd");
  }

  initiateForm() {
    this.prepaidConsumerForm = this.formBuilder.group({
      consumerNumber: new FormControl(
        "",
        Validators.compose([
          // Validators.required,
          // Validators.minLength(7),
          // Validators.maxLength(10),
          // Validators.pattern("^[0-9 ]+$")])),
          Validators.pattern("^[0-9 ]+$"),
        ])
      ),
      meterNo: new FormControl(""),
      captcha: new FormControl("", Validators.compose([Validators.required])),
    });
  }

  getConsumerDetails() {
    this.httpService
      .getUserDetailsByConsNo(this.sessionData.consumerId)
      .subscribe(
        (data) => {
          console.log(data);
        },
        (error) => { },
        () => { }
      );
  }

  onSearchChange(searchValue: string): void {
    if (searchValue.length == 3) {
      if (searchValue == this.captchaView) {
        this.isCaptchaMatched = true;
      } else {
        this.isCaptchaMatched = false;
      }
    } else {
      this.isCaptchaMatched = true;
    }
  }

  generateCaptcha = function () {
    var self = this;
    self.captchaView = "";
    var cap = self.randomString(3);
    self.captchaView = cap;
  };

  randomString = function (len, an) {
    an = an && an.toLowerCase();
    var str = "",
      i = 0,
      min = an == "a" ? 10 : 0,
      max = an == "n" ? 10 : 62;
    for (; i++ < len;) {
      var r = (Math.random() * (max - min) + min) << 0;
      str += String.fromCharCode((r += r > 9 ? (r < 36 ? 55 : 61) : 48));
    }
    return str;
  };

  getSession = function () {
    this.sessionData = this.session.getSessionDetails();
    console.log("this.sessionData", this.sessionData);
    // this.getConsumerDetails();
  };

  filterPaymentDetails(pageno = 0) {
    if (pageno == 0) {
      this.pageNo = 0;
    }

    if (
      this.fromDate != null &&
      this.toDate != null &&
      new Date(this.fromDate) > new Date(this.toDate)
    ) {
      this.displayDateFilterError = true;
      setTimeout(() => {
        this.displayDateFilterError = false;
      }, 3000);
      return false;
    }


    this.showForm = false;
    this.serviceOn = true;
    this.errorMsg = "";
    this.transactionList = [];


    let param = {
      fromDate:
        this.fromDate == null || this.fromDate == ""
          ? null
          : this.datePipe.transform(new Date(this.fromDate), "yyyy-MM-dd"),
      toDate:
        this.toDate == null || this.toDate == ""
          ? null
          : this.datePipe.transform(new Date(this.toDate), "yyyy-MM-dd"),
      meterNo: this.prepaidConsumerForm.value.meterNo,
      consumerNo: this.prepaidConsumerForm.value.consumerNumber,
      pageNo: this.pageNo,
      pageSize: 10
    };



    this.httpService.prepaidPaymentConsHistories(param).subscribe(
      (result: any) => {
        this.serviceOn = true;
        if (result.status == 1) {
          this.transactionList = result["response"];
          this.consumerNoShow = result["response"][0].consumerNo;
          this.vendorId = result["response"][0].vendorId;
          this.showTransactionTable = true;
          console.log("******List ", this.transactionList)
          console.log("******vendorId ", this.vendorId)
          for (let item of this.transactionList) {
            if (result["response"][0].vendorId == 3) {
              if (null != item.legacySecureData && null != item.legacySecureData.EncryptedToken && item.legacySecureData.EncryptedToken !== 'N/A') {
                item.legacySecureData.EncryptedToken = item.legacySecureData.EncryptedToken.match(/.{1,20}/g);
                console.log("DETAILS RESPONSE: ", item.legacySecureData.EncryptedToken)

                
              }
            }
            else if (result["response"][0].vendorId == 4) {
              if (null != item.oldCapitalData && null != item.oldCapitalData.token && item.oldCapitalData.token !== 'N/A') {
                item.oldCapitalData.token = item.oldCapitalData.token.match(/.{1,20}/g);
              }

            }


          }

          // if(result["response"][0].vendorId == 2){
          //   result["response"].forEach((element) => {
          //     if (element.secureData != null) {
          //       this.transactionList.push(element);
          //     }
          //   });
          // }
          // else if(result["response"][0].vendorId == 1){
          //   result["response"].forEach((element) => {
          //     if (element.capitalData != null) {
          //       this.transactionList.push(element);
          //     }
          //   });
          // }

          this.totalCount = result["total"];
          this.maxPageNo = Math.ceil(this.totalCount / this.pageSize) - 1;
          this.paginationLinks = [];
          for (
            let pageLink = this.pageNo - 2;
            pageLink <= this.pageNo + 2;
            pageLink++
          ) {
            if (pageLink < 0 || pageLink > this.maxPageNo) {
              continue;
            }
            this.paginationLinks.push(pageLink + 1);
          }

          this.serviceOn = false;
        } else {
          this.errorMsg = result.message;
          this.showTransactionTable = false;
        }
      },
      (error: any) => {
        this.errorMsg = error;
        this.serviceOn = false;
      },
      () => {
        this.serviceOn = false;
      }
    );
  }





  back() {
    this.initiateForm();
    this.showForm = true;
    this.showTransactionTable = false;
    this.errorMsg = "";
    this.consumerNoShow = '';
  }

  moveToPage(pagePosition) {
    switch (pagePosition) {
      case "first":
        this.pageNo = 0;
        break;
      case "previous":
        if (this.pageNo > 0) {
          this.pageNo -= 1;
        }
        break;
      case "next":
        if (this.pageNo < this.maxPageNo) {
          this.pageNo += 1;
        }
        break;
      case "last":
        this.pageNo = this.maxPageNo;
        break;
      default:
        this.pageNo = pagePosition - 1;
        break;
    }
    this.filterPaymentDetails(this.pageNo);
  }
}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/view-prepaid-transaction/view-prepaid-transaction.component.ts